import { useEffect, useState } from 'react';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import styles from 'global/styles/Profile.module.scss';
import { api } from '../../global/api';
import checkAuth from '../../global/api/auth';
import normalizeGoods from '../../shared/lib/normalizers/normalizeGoods';
import { Icon } from '@nebo-team-dev/vobaza.ui.icon';

import ProfileSidebar from '../../components/Profile/Sidebar';
import { ProfileEmptyField } from 'app/profile';
import ProfileFavoriteItem, { FavoriteGood } from '../../components/Profile/Favorite/Item';
import { CartModal } from 'widgets/products';
import { useDispatch } from 'shared/lib/hooks/useDispatch';
import { setFavorites } from 'src/store/goods';
import { RootState } from 'src/store';
import type { IProductError } from 'entities/products/lib/checkProductToBuy';
import CartItemChangeModal from 'components/Cart/Modal/CartItemChangeModal';

interface Props {
  initialGoods: FavoriteGood[];
}

export default function Home({ initialGoods }: Props) {
  const [goods, setGoods] = useState(initialGoods);
  const [errorToBuy, setErrorToBuy] = useState<IProductError | null>(null);

  const dispatch = useDispatch();
  const router = useRouter();

  const goBack = () => {
    router.back();
  };
  const isUserLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);

  const onDelete = (id: number) => {
    setGoods((prevArray) => prevArray.filter((item) => item.id !== id));
  };
  useEffect(() => {
    setGoods(initialGoods);

    const favoriteIds = initialGoods?.map(({ id }) => id);
    dispatch(setFavorites(favoriteIds));
  }, [initialGoods]);

  const title = isUserLoggedIn ? 'Профиль' : 'Избранное';

  const handleError = (goodError?: IProductError | null) => {
    setErrorToBuy(goodError);
  };

  const profileSidebar = () =>
    isUserLoggedIn && (
      <div className={styles.profileSidebarBlock}>
        <ProfileSidebar />
      </div>
    );

  return (
    <div>
      {errorToBuy && (
        <CartItemChangeModal
          title={errorToBuy.title || ''}
          description={errorToBuy.description || ''}
          onClose={() => setErrorToBuy(null)}
        />
      )}

      <CartModal />
      <div className="container">
        <div className={styles.profileContainer}>
          <h2 className={styles.profileTitle}>{title}</h2>
          <div className={styles.profileContent}>
            {profileSidebar()}
            <div className={styles.profileContentBlock}>
              <div className={styles.profileTop}>
                <div className={styles.profileBack} onClick={goBack}>
                  <Icon name="ArrowLeft" /> Назад
                </div>
              </div>
              {isUserLoggedIn && <h2 className={styles.profileSubtitle}>Избранное</h2>}
              {goods?.length > 0 ? (
                <div>
                  {goods.map((good) => (
                    <ProfileFavoriteItem key={good.name} good={good} onDelete={onDelete} onError={handleError} />
                  ))}
                </div>
              ) : (
                <ProfileEmptyField text="Пусто" />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ req }) => {
  let initialGoods = null;

  try {
    await checkAuth(req, true);
    const favoritesRes = await api.getFavorites();

    initialGoods = normalizeGoods(favoritesRes.data.data);
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      initialGoods,
    },
  };
};
